import React, { ForwardedRef } from 'react';
import { Track, tracker } from 'angieslist-app-platform';
import './RangeSlider.scss';
import { ONLINE_UPGRADE_OFFER_LOW_COST_TRIAL } from '../../../../common/commonConstants';

const buildHashMarks = (max: number) => {
  const results: number[] = [];
  while (results.length !== max - 1) {
    const randomNum = Math.floor(Math.random() * max);
    if (!results.includes(randomNum)) results.push(randomNum);
  }
  return results;
};

export interface NorthStarRangeSliderProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  min: number;
  max: number;
  step: number;
  value: number;
  setValue: (value: number) => void;
  bubbleContent: string | Element;
  onlineUpgradeOffer: string;
}

// GOTCHA: this needs to be changed if CSS .sliderThumb width changes
const thumbWidth = 28;

// eslint-disable-next-line max-len
const RangeSlider = React.forwardRef((props: NorthStarRangeSliderProps, ref: ForwardedRef<HTMLInputElement>) => {
  const {
    min, max, step, value, setValue, bubbleContent, onlineUpgradeOffer,
  } = props;

  const handleChange = (e) => {
    setValue(parseInt(e.target.value, 10));
    tracker.track('Item Clicked', {
      activityLocation: 'SP : Home',
      description: 'Lead calculator slider',
    });
  };

  const percentage = ((value - min) / (max - min)) * 100;
  const numOfSteps = (max - min) / step;
  const numHashMarks = numOfSteps + 2;
  const thumbOffsetValue = thumbWidth * (percentage / 100);

  const isLowCostTrial = onlineUpgradeOffer === ONLINE_UPGRADE_OFFER_LOW_COST_TRIAL;

  return (
    <div className="slider-container">
      <Track>
        <input
          ref={ref}
          id="range-slider"
          type="range"
          min={min}
          max={max}
          step={step}
          className="sliderRange"
          onChange={e => handleChange(e)}
          style={{ backgroundSize: `${percentage}% 100%` }}
          value={value}
        />
      </Track>
      <div className="hashMarksContainer">
        {buildHashMarks(numHashMarks).map(val => (
          <div
            data-testid="hash-marks"
            className="hashMarks"
            key={val}
          />
            ))}
      </div>

      <div
        className={`sliderBubble ${isLowCostTrial && 'sliderBubbleFree'}`}
        style={{
            left: `calc(${percentage}% - ${thumbOffsetValue + 15}px)`,
          }}
      >
        {bubbleContent}
      </div>
      <div
        className="sliderThumb"
        style={{
            left: `calc(${percentage}% - ${thumbOffsetValue}px)`,
          }}
      />
    </div>
  );
});

RangeSlider.displayName = 'RangeSlider';

export default RangeSlider;



// WEBPACK FOOTER //
// ./src/modules/home/browser/components/LeadCalculator/RangeSlider.js